import * as React from "react";
import type Scene from "../../models/Scene";
import type Connection from "../../models/Connection";
import type Channel from "../../models/Channel";
import KnxProperty from "../KnxProperty";
import type Device from "../../models/Device";
import { KnxSceneBehaviour, KnxSceneInfo } from "../../models/KnxSceneInfo";
import { useEffect } from "react";
import { allignColumnTreeview } from "../../modelViews/GraficElementUtils";
import { useOnChangeWatcher } from "../../models/useOnChangeWatcher";

export function SceneBehaviours(props: { channel: Channel | undefined; scene?: Scene; connection?: Connection }) {
  const { channel, scene, connection } = props;
  const sceneInfo = connection?.knxSceneInfo;
  const refBehaviorRowsRoot = React.useRef<HTMLDivElement>(null);

  const actor = channel?.parent as Device;

  useOnChangeWatcher(actor);
  useOnChangeWatcher(actor?.knxParameterViewer);

  useEffect(() => {
    if (refBehaviorRowsRoot.current) {
      // allignColumnTreeview("scenePropValue", refBehaviorRowsRoot.current as HTMLElement, 400); // no itx
      allignColumnTreeview("scenePropLabel", refBehaviorRowsRoot.current as HTMLElement, 400); // no itx
    }
  });

  console.log("SceneBehaviours Render");

  if (!sceneInfo?.behaviours) {
    return null;
  }

  if (!channel) {
    return null;
  }

  const behaviorElements = sceneInfo.behaviours
    .filter(() => sceneInfo.device != undefined)
    .map((behaviour: KnxSceneBehaviour) => (
      <KnxProperty
        key={`${behaviour.moduleId}-${behaviour.instanceId}-${scene?.id ?? "no-scene"}-${connection?.id ?? "no-connection"}`}
        device={sceneInfo.device!}
        data={behaviour.data}
        label={behaviour.label}
        instanceId={behaviour.instanceId}
        moduleId={behaviour.moduleId}
        parameterId={behaviour.parameterId}
      />
    ));

  let warningText = "";

  if (!channel?.parent) {
    warningText = state.translate("sceneConnectionProperties.noConnectedChannel", "no connected Channel");
  } else if ((channel.parent as Device)?.template == undefined) {
    warningText = state.translate(
      "sceneConnectionProperties.selectProductForT1",
      "Wähle ein Produkt für diesen T1 aus!",
      {
        T1: state.translate(`components.${channel.parent.className}`, channel.parent.className),
      },
    );
  } else if (sceneInfo.behaviours.length == 0) {
    warningText = state.translate(
      "sceneConnectionProperties.sceneSettingsNotAvailableJet",
      " Szeneneinstellungen noch nicht möglich.",
    );
  }

  return (
    <div
      id="sceneBehaviours"
      ref={refBehaviorRowsRoot}
      className="estadaColumn"
      style={{ marginLeft: "50px", alignItems: "flex-start" }}
    >
      {behaviorElements}
      {warningText != "" && (
        <div style={{ display: "flex", flexDirection: "row", padding: "5px" }}>
          <img
            src="images/warning.png"
            style={{
              width: "25px",
              height: "25px",
              marginLeft: "10px",
              position: "relative",
            }}
          />
          {warningText}
        </div>
      )}
    </div>
  );
}
